import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import {
  deleteFactoresCriticidad,
  editFactoresCriticidad,
  getFactoresCriticidad,
  saveFactoresCriticidad,
} from "../../../redux/Carrera_Sucesion/FactoresCriticidad/actions";
import SidebarCarreraSucesion from "../../../components/Carrera_Sucesion/SidebarCarreraSucesion";
import { getCriticidad } from "../../../redux/Carrera_Sucesion/Criticidad/actions";

const FactoresCriticidad = () => {
  const fecha = new Date();
  var anioActual = fecha.getFullYear();

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    nombre: Yup.string().required("**Campo requerido"),
    tipo_criticidad: Yup.string().required("**Campo requerido"),
  });

  const {
    loading,
    saveLoading,
    factoresCriticidad,
    factoresCriticidadError,
    formError,
  } = useSelector((store) => store.factoresCriticidad);
  const {
    loading: loadingTipoCriticidad,
    tipoCriticidad,
    tipoCriticidadError,
  } = useSelector((store) => store.tipoCriticidad);
  const pages = Math.ceil(
    factoresCriticidad ? factoresCriticidad.count / limit : 0
  );

  const columns = [
    {
      Header: "Descripción",
      accessor: "nombre",
      Filter: "",
    },
    {
      Header: "Tipo de Criticidad",
      accessor: "tipoCriticidad",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_tipo_criticidad &&
          value.row.original.list_tipo_criticidad[0]
            ? value.row.original.list_tipo_criticidad[0].nombre
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const _getFactoresCriticidad = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getFactoresCriticidad({
        offset: offs,
        limit: lim,
        tipo_busqueda: "nombre",
        filter: filt,
      })
    );

  useEffect(() => {
    _getFactoresCriticidad();
    dispatch(getCriticidad({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactoresCriticidad(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    if (!edit) {
      req.anio = anioActual;
      
     dispatch(saveFactoresCriticidad(req, setShowModal));
    } else {
      dispatch(editFactoresCriticidad(req, editItem.id, index, setShowModal));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactoresCriticidad(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteFactoresCriticidad(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCarreraSucesion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              factores de criticidad
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            factoresCriticidad &&
            factoresCriticidad.count > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={factoresCriticidad.data}
                    />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={factoresCriticidad.count}
                  pages={pages}
                  pagFunc={_getFactoresCriticidad}
                />
              </>
            )
          )}
          {(!loading &&
            factoresCriticidad &&
            factoresCriticidad.count === 0 &&
            factoresCriticidadError === "") ||
          (!loading &&
            !factoresCriticidad &&
            factoresCriticidadError === "") ? (
            <Alert variant="info" className="mt-4 mb-1 mx-3">
              Aún no hay registros, comience agregando algunos
            </Alert>
          ) : null}
          {!loading && !!factoresCriticidadError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {factoresCriticidadError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
            tipo_criticidad: edit ? editItem.list_tipo_criticidad[0].id : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar factores de criticidad" : "Crear factores de criticidad"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Descripción
                  </Form.Label>
                  <Form.Control
                    id="nombre"
                    name="nombre"
                    isInvalid={touched.nombre && errors.nombre}
                    isValid={touched.nombre && !errors.nombre}
                    onBlur={handleBlur("nombre")}
                    onChange={handleChange}
                    value={values.nombre}
                    className="rounded-pill"
                    type="text"
                    placeholder="descripción"
                  ></Form.Control>
                  {touched.nombre && errors.nombre && (
                    <div>
                      <small className="text-danger">{errors.nombre}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Tipo Criticidad
                  </Form.Label>
                  <Row className="d-flex flex-wrap justify-content-start align-items-center">
                    <Col sm={loadingTipoCriticidad ? "10" : "12"}>
                      <Form.Control
                        as="select"
                        id="tipo_criticidad"
                        name="tipo_criticidad"
                        className="col rounded-pill"
                        isInvalid={touched.tipo_criticidad && errors.tipo_criticidad}
                        isValid={touched.tipo_criticidad && !errors.tipo_criticidad}
                        onBlur={handleBlur("tipo_criticidad")}
                        value={values.tipo_criticidad}
                        disabled={
                          loadingTipoCriticidad ||
                          !tipoCriticidad ||
                          (tipoCriticidad && tipoCriticidad.count === 0)
                        }
                        onChange={handleChange}
                      >
                        <option
                          className="text-muted"
                          value=""
                          selected
                          disabled
                        >
                          Seleccionar Tipo de Criticidad
                        </option>
                        {tipoCriticidad &&
                          tipoCriticidad.count > 0 &&
                          tipoCriticidad.data.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                      </Form.Control>
                    </Col>
                    {loadingTipoCriticidad ? (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    ) : null}
                  </Row>
                  {!!tipoCriticidadError && (
                    <Col>
                      <small className="text-danger">{tipoCriticidadError}</small>
                    </Col>
                  )}
                  {touched.tipo_criticidad && errors.tipo_criticidad && (
                    <Col>
                      <small className="text-danger">{errors.tipo_criticidad}</small>
                    </Col>
                  )}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default FactoresCriticidad;
